export const getPaths = (userGroup: number): any => {
  console.log('>>> getPaths:', userGroup)
  return {
    0: [],
    // Admins
    1: [
      {
        icon: 'dashboard',
        name: 'Dashboard',
        path: '/admin/dashboard',
      },
      {
        icon: 'phone',
        name: 'Ouvidoria',
        path: '/admin/ouvidoria',

      },
    ],
    // Gestão
    2: [
      {
        icon: 'dashboard',
        name: 'Dashboard',
        path: '/admin/dashboard',
      },
    ],
    3: [
      {
        icon: 'dashboard',
        name: 'Dashboard',
        path: '/admin/dashboard',
      },
    ],

    //   {
    //     icon: 'contracts',
    //     name: 'Contratos',
    //     path: '/admin/contracts',
    //   },
    //   {
    //     icon: 'supplier',
    //     name: 'Fornecedores',
    //     path: '/admin/suppliers',
    //   },
    // Protocolo
    // 3: [
    //   {
    //     icon: 'dashboard',
    //     name: 'Dashboard',
    //     path: '/admin/dashboard',
    //   },
    // ],
    // Financeiro
    // 4: [
    //   {
    //     icon: 'dashboard',
    //     name: 'Dashboard',
    //     path: '/admin/dashboard',
    //   },
    // ],
    // SCC - Supervição de Contratos e Convênios.
    // 5: [
    //   {
    //     icon: 'dashboard',
    //     name: 'Dashboard',
    //     path: '/admin/dashboard',
    //   },
    //   {
    //     icon: 'contracts',
    //     name: 'Contratos',
    //     path: '/admin/contracts',
    //   },
    //   {
    //     icon: 'supplier',
    //     name: 'Fornecedores',
    //     path: '/admin/suppliers',
    //   },
    //   {
    //     icon: 'group',
    //     name: 'Grupos',
    //     path: '/admin/groups',
    //   },
    //   {
    //     icon: 'expenses',
    //     name: 'Despesas',
    //     path: '/admin/expenses',
    //   },
    // ]
  }[userGroup]
}
